// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgApple24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M3 12.9211C3 12.9216 3 12.922 3 12.9225C3.00019 15.6038 4.06411 18.4286 5.32655 20.2531C6.25613 21.5941 7.36097 23.1053 8.81632 23.0495C9.46731 23.0235 9.92993 22.8262 10.4081 22.6222C10.9597 22.3869 11.5321 22.1427 12.4382 22.1427C13.3034 22.1427 13.851 22.38 14.3774 22.608C14.88 22.8258 15.3633 23.0352 16.0854 23.0215C17.5915 22.9911 18.5465 21.65 19.4685 20.3039C20.4879 18.8125 20.934 17.3653 20.9921 17.177C20.9946 17.1687 20.9964 17.1628 20.9975 17.1595L20.9974 17.1595C20.958 17.1443 18.0614 16.0306 18.0309 12.6919C18.0062 9.96934 20.1964 8.62388 20.4082 8.49381C20.4139 8.49028 20.4182 8.48765 20.4209 8.4859C19.1205 6.58355 17.0988 6.32448 16.3775 6.294C15.3261 6.18684 14.3051 6.58962 13.4707 6.91879C12.9404 7.12796 12.4856 7.30741 12.1461 7.30741C11.7677 7.30741 11.3008 7.12214 10.7771 6.91433C10.0913 6.64224 9.30813 6.3315 8.49883 6.34734C6.62188 6.37528 4.89223 7.43694 3.92454 9.11833C3.2712 10.2512 3.0001 11.5679 3 12.9211Z"
				/>
				<path d="M15.2497 4.47816C16.0218 3.54349 16.5424 2.24308 16.4002 0.947754C15.2878 0.993471 13.9416 1.68939 13.1441 2.62406C12.4304 3.44952 11.8031 4.77279 11.9732 6.04272C13.2101 6.13923 14.4775 5.41029 15.2497 4.47816Z" />
			</Svg>
		);
	}
);
SvgApple24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgApple24;
